import { z } from 'zod';

export const productFilterSchema = z.object({
    brands: z
        .array(z.string())
        .nullable()
        .catch(null)
        .transform(data => (Array.isArray(data) && data.length === 0 ? null : data)),
    colors: z
        .array(z.string())
        .nullable()
        .catch(null)
        .transform(data => (Array.isArray(data) && data.length === 0 ? null : data)),
    sizes: z
        .array(z.string())
        .nullable()
        .catch(null)
        .transform(data => (Array.isArray(data) && data.length === 0 ? null : data)),
    price: z.tuple([z.number(), z.number()]).default([0, 200_000]),
});

export type ProductFilterSchema = z.infer<typeof productFilterSchema>;
